import { create } from 'zustand';

interface StoreID {
    postId: number | null;
    setPostId: (id: number | null) => void;
}

const useStoreID = create<StoreID>((set) => ({
    postId: null,
    setPostId: (id) => set({ postId: id }),
}));

export default useStoreID;
